import React from 'react';
import { DashboardLayout } from '../layouts/DashboardLayout';
import { WorkforceBillingSection } from '../components/billing/WorkforceBillingSection';

export default function WorkforceBillingPage() {
  return (
    <DashboardLayout>
      <WorkforceBillingSection />
    </DashboardLayout>
  );
}
